import { useParams } from "react-router-dom";
import AddListingsForm from "./AddListingsForm";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../components/UserContext";
import WorkspaceList from "../../components/WorkspaceList";
import { WorkspaceCardData } from "../../components/Interfaces/WorkspaceCard";
import { SearchWorkspaces } from "../../components/Search";

export default function ListingsPage() {
  const { action } = useParams();
  const { user } = useContext(UserContext);
  const [workspaces, setWorkspaces] = useState<WorkspaceCardData[]>([]);

  useEffect(() => {
    // Execute search with all null params on initial render
    onRenderSearchWorkspaces();
  }, []);

  async function onRenderSearchWorkspaces() {
    const workspace = await SearchWorkspaces({
      location: "",
      moveInDate: null,
      capacity: null,
      userId: user?.id || null, // Use user ID if available, otherwise null
      userOnly: true,
    });

    if (workspace instanceof Error) {
      console.error(workspace.message);
      // Handle error
    } else {
      // Use the workspace data
      console.log(workspace);
      setWorkspaces(workspace.workspaces);
    }
  }

  return (
    <div>
      {action !== "new" && (
        <div className="px-4 py-8">
          <WorkspaceList workspaces={workspaces} />
        </div>
      )}
      {action === "new" && <AddListingsForm />}
    </div>
  );
}
